/* eslint-disable ember/no-computed-properties-in-native-classes */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';

export default class AssessmentsController extends Controller {
  @service
  router;

  @computed('router.currentRouteName')
  get currentTab() {
    // Extract the 4th segment of the route name (group.insights.assessments.*).
    return this.router.currentRouteName.split('.').slice(3, 4)[0];
  }

  @tracked assessmentId = '';

  @computed('assessmentId', 'assessmentOptions.[]')
  get selectedAssessmentOption() {
    return this.assessmentOptions.find(
      (item) => item.value === this.assessmentId,
    );
  }

  @computed('model.assessments.[]', 'currentTab')
  get assessmentOptions() {
    let options = [];

    this.model.assessments
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''))
      .forEach((assessment) => {
        options.push({
          icon: 'check',
          label: assessment.label,
          value: assessment.id,
          type: 'assessment',
        });
      });

    return options;
  }

  @action
  setAssessment(option) {
    // Assessment selected - go to assessment route
    this.router.transitionTo(
      `group.insights.assessments.${this.currentTab}.assessment`,
      this.model.group.id,
      option.value,
    );
  }

  @action
  switchTab(tab) {
    switch (tab) {
      case 'progress':
      case 'current':
        this.router.transitionTo(
          `group.insights.assessments.${tab}.assessment`,
          this.model.group.id,
          this.assessmentId,
        );
        break;
    }
  }
}
